const SubmitAbility = () => {
  const selectedDestinations = document.querySelectorAll("div[name^=selector\\[")
  const selectedDestinationsArray = Array.from(selectedDestinations)
  const values = selectedDestinationsArray.map((dest) => {
    let destTypeName = ''
    if (dest.getAttribute('data-destination-type') === 'app') {
      destTypeName = 'アプリ'
    } else if (dest.getAttribute('data-destination-type') === 'article') {
      destTypeName = '物件'
    } else if (dest.getAttribute('data-destination-type') === 'delivery_group') {
      destTypeName = '配信グループ'
    } else if (dest.getAttribute('data-destination-type') === 'member_dwelling_unit') {
      destTypeName = '会員住戸'
    }
    return {
      name: dest.getAttribute('data-destination-name'),
      type: destTypeName,
    }
  })

  let isActive = false;
  // Check if there is at least one destination name that is not empty
  const hasSomeDestinationSetup = values.some((dest) => (dest.name != "" && dest.name != null));
  if (hasSomeDestinationSetup === true) {
    isActive = true
  } else {
    isActive = false
  }
  return isActive
}

export default SubmitAbility;
